export default {
  experience: "candidate/profile/experience",
  delExperience: "candidate/profile/experience/delete",
  SINGLEEXP: (id) => `candidate/profile/experience/${id}`,
};
